import vn_simple_rounded from "../../../../assets/images/vn_simple_rounded.png";
import search_agent_standard from "../../../../assets/images/search_agent_standard.png";
import company_agent_standard from "../../../../assets/images/company_agent_standard.png";

export const agents = [
  {
    id: 0,
    name: "Hybrid",
    apiName: "MAIN",
    description: "Fast answers drawn from existing context - no live searches",
  },
  {
    id: 1,
    name: "Discovery",
    apiName: "DISCOVERY",
    description:
      "Deeper investigation across the web - pick Quick, Standard, or Deep",
  },
];

export const DEFAULT_AGENT = agents[0];

export const panelClasses = [
  "relative mx-auto w-full overflow-hidden",
  "rounded-2xl bg-surface/90 backdrop-blur-md",
  "border border-surfaceBorder",
  "shadow-[0_4px_24px_rgba(0,0,0,0.08)]",
  "dark:shadow-[0_4px_24px_rgba(0,0,0,0.45)]",
].join(" ");

export const EMOJI_CATEGORIES = {
  Smileys: [
    "😀",
    "😂",
    "🥹",
    "😊",
    "😇",
    "🥰",
    "😍",
    "🤩",
    "😘",
    "😜",
    "🤪",
    "😎",
    "🤓",
    "🧐",
    "😤",
    "😭",
    "🥺",
    "😱",
    "🤯",
    "🫡",
    "🫠",
    "🤔",
    "🤫",
    "🫣",
    "😶",
    "😏",
    "😈",
  ],
  Gestures: [
    "👍",
    "👎",
    "👋",
    "🤝",
    "🙏",
    "💪",
    "🫶",
    "👏",
    "🤞",
    "✌️",
    "🤙",
    "👀",
    "🧠",
    "💀",
    "❤️",
    "🔥",
    "⭐",
    "💯",
    "✅",
    "❌",
    "⚡",
    "💡",
    "🎯",
    "🚀",
    "💰",
    "📌",
    "🔗",
  ],
  Work: [
    "📊",
    "📈",
    "📉",
    "📋",
    "📝",
    "💼",
    "🗂️",
    "📁",
    "🔍",
    "⏰",
    "📅",
    "🏆",
    "🎉",
    "🤖",
    "💻",
    "🛠️",
    "⚙️",
    "📧",
    "📞",
    "🔒",
    "🔑",
    "🏷️",
    "📎",
    "✏️",
    "🗑️",
    "📤",
    "📥",
  ],
};

// Re-export image assets so other components can import from one place
export { vn_simple_rounded, search_agent_standard, company_agent_standard };
